module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_9_Malouf.fd8ca150aefd7a696c06b8a33bbdb587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_9_Malouf.jpg
// module id = 792
// module chunks = 0